export default __webpack_public_path__ + "static/itpodnik-example1-8bff696f39f35214538d686e99b69e93.png";